module.exports = __webpack_public_path__ + "assets/img/btn-view-mecha-info-eefdaca1.png";